<template>
  <div class="custom-management">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="素材需求管理" name="requirement">
        <RequirementManagement />
      </el-tab-pane>
      <el-tab-pane label="私人定制管理" name="custom">
        <CustomOrderManagement />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import RequirementManagement from '@/components/admin/RequirementManagement.vue'
import CustomOrderManagement from '@/components/admin/CustomOrderManagement.vue'

const activeTab = ref('requirement')
</script> 